import { useEffect, useState } from 'react'

/**
 * Returns `value` after it has stopped changing for `delay` ms.
 *
 * The codebase debounces search in three places today (DiscoverView 380ms,
 * Feed 400ms, behaviorTracker) by hand-rolling a setTimeout inside a useEffect.
 * This is the same pattern, extracted so Spotlight does not add a fourth copy.
 */
const useDebouncedValue = (value, delay = 350) => {
  const [debounced, setDebounced] = useState(value)

  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay)
    return () => clearTimeout(timer)
  }, [value, delay])

  return debounced
}

export default useDebouncedValue
